"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getAppHostConfig_1 = __importDefault(require("./getAppHostConfig"));
const getEnvironmentNameFromHost = () => {
    const { BASE_HOST } = getAppHostConfig_1.default(window.location.hostname, window.location.port);
    return {
        'atms.a2z.com': 'prod',
        'staging.atms.a2z.com': 'staging',
        'beta2.atms.a2z.com': 'beta',
        'load.atms.a2z.com': 'load',
    }[BASE_HOST];
};
exports.default = getEnvironmentNameFromHost() || 'dev';
//# sourceMappingURL=environmentName.js.map